import { useNavigate } from "react-router-dom";

import type { Route } from "../../bootstrap/router.ts";
import { router } from "../../bootstrap/router.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useAppNavigation() {
  const navigate = useNavigate();

  return {
    navigateTo: (route: Route): void => {
      navigate(router.getUrl(route));
    },
  };
}
